import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children }) => {
  // Check if user is authenticated (check sessionStorage or localStorage)
  const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';
  
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }
  
  return children;
};
